import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import GridDatePicker from '../../../components/common/inputs/GridDatePicker';
import { Grid, MenuItem, SelectChangeEvent } from '@mui/material';
import GridSelect from '../../../components/common/inputs/GridSelect';
import CustomUploadButton from '../../../components/common/button/CustomUploadButton';
import { Loader } from '../../../components/common/Loader';
import ModalCustom from '../../../components/common/Modal';
import AutocompleteGridmui from '../../../components/common/autocomplete/AutocompleteGridmui';
import { DivStyled } from '../../../assets/styles/components/DivStyledLableInputs';
import {
  AddIconButton,
  RemoveIconButton,
} from '../../../components/common/button/CustomIconButton';
import PartTable from './components/PartTable';
import { Checkbox } from '@mui/material';
import { StyledNotesField } from '../../../components/common/FormControlMui';
import DescriptionTextfield from '../../../components/common/DescriptionNotes';
import GridTimePicker from '../../../components/common/inputs/GridTimePicker';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [data, setData] = useState<any>({
    exclude_report: false,
    effectivness: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item: any) => {
      return {
        date: '',
        invoice_no: '',
        qty: '',
        status: '',
      };
    }),
    files: [],
    images: [],
  });
  const [files, setFiles] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Supplier Complaint' : 'Create Supplier Complaint'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );
  const [isPartModal, setIsPartModal] = useState(false);
  const [render, setRender] = useState(false);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/supplierComplaintRoutes/${id}`)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);
  useEffect(() => {
    axios
      .get(`/api/vendorRoute/vendor/forAutoComplete`)
      .then((res) => {
        console.log(res);
        setVendors(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function handleCustomerData(
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>
  ) {
    setData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  }
  const handleSumbit = async () => {
    if (!data.vendor_id) {
      alert('Please enter Supplier name');
      return;
    }
    const ans = await confirmSubmit();
    if (!ans) return;

    setIsLoading(true);
    const formData = new FormData();

    if (typeof data.effectivness === 'object') {
      formData.append('effectivness', JSON.stringify(data.effectivness));
    }
    if (typeof data.vendor_id === 'object') {
      data.vendor_id = data.vendor_id._id;
    }
    if (typeof data.part_id === 'object') {
      data.part_id = data.part_id._id;
    }
    for (const key in data) {
      if (data[key] || typeof data[key] == 'boolean') {
        if (key !== 'files' && key !== 'images') {
          formData.append(key, data[key]);
        }
      }
    }

    if (files) {
      for (const key of Object.keys(files)) {
        formData.append('files', files[key]);
      }
    }

    if (id) {
      await axios
        .put(`/api/supplierComplaintRoutes/${id}`, formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/supplierComplaintRoutes', formData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <Loader loader={isLoading} />
      <GridDatePicker
        label_name="Date of QPR"
        html_for={'qpr_date'}
        value={data?.qpr_date || null}
        onChange={(date) => {
          data.qpr_date = date;
        }}
      />
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part No.'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof data?.part_id === 'object' && data?.part_id !== null
                  ? data?.part_id?.part_number
                  : data?.partNumber || ''}
              </p>
            </Grid>

            {data.part_id ? (
              <Grid item xs={2}>
                <RemoveIconButton
                  tooltipTitle="remove part"
                  onClick={() => {
                    data.part_id = null;
                    data.partNumber = null;
                    data.partName = null;

                    setRender((prev) => !prev);
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={2}>
                <AddIconButton
                  tooltipTitle="add part"
                  onClick={() => {
                    setIsPartModal(true);
                  }}
                />
              </Grid>
            )}
          </Grid>
        </div>
      </DivStyled>
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Name'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof data?.part_id === 'object' && data?.part_id !== null
                  ? data?.part_id?.part_name
                  : data?.partName || ''}
              </p>
            </Grid>
          </Grid>
        </div>
      </DivStyled>
      <AutocompleteGridmui
        id={'vendor_name'}
        label={'Supplier Name'}
        option_name={'vender_name'}
        value={data.vender_name || data.vendor_id || ''}
        arrayofObj={vendors}
        onChange={(e, value) => {
          data.vendor_id = value._id;
          data.vender_name = value;
          setRender((prev) => !prev);
        }}
      />
      <GridInputs
        id={'information_mode'}
        name={'information_mode'}
        html_for={'information_mode'}
        label_name={'Information Mode:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.information_mode || ''}
        onChange={handleCustomerData}
      />
      <GridDatePicker
        label_name="Date of Information"
        html_for={'information_date'}
        value={data?.information_date || null}
        onChange={(date) => {
          data.information_date = date;
        }}
      />
      <GridTimePicker
        label_name="Time of Information"
        html_for={'information_time'}
        value={data?.information_time || null}
        onChange={(date) => {
          data.information_time = date;
        }}
      />

      <GridInputs
        id={'information_person'}
        name={'information_person'}
        html_for={'information_person'}
        label_name={'Information person:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.information_person || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'complaint_qty'}
        name={'complaint_qty'}
        html_for={'complaint_qty'}
        label_name={'Complaint QTY:'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.complaint_qty || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'defects'}
        name={'defects'}
        html_for={'defects'}
        label_name={'Defect:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.defects || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'first_response_time'}
        name={'first_response_time'}
        html_for={'first_response_time'}
        label_name={'First Response time:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.first_response_time || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'response_time'}
        name={'response_time'}
        html_for={'response_time'}
        label_name={'Response time:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.response_time || ''}
        onChange={handleCustomerData}
      />
      <StyledNotesField>
        <DescriptionTextfield
          name="observation_of_gamba"
          onChange={handleCustomerData}
          value={data.observation_of_gamba || ''}
          label={'Observation of Gamba:'}
        />
      </StyledNotesField>
      <h1>Supplier end FG & ASSY LINE</h1>
      <GridInputs
        id={'supplier_end_ok_qty'}
        name={'supplier_end_ok_qty'}
        html_for={'supplier_end_ok_qty'}
        label_name={'OK:'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.supplier_end_ok_qty || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'supplier_end_ng_qty'}
        name={'supplier_end_ng_qty'}
        html_for={'supplier_end_ng_qty'}
        label_name={'NG:'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.supplier_end_ng_qty || ''}
        onChange={handleCustomerData}
      />

      <h1>TCS end FG & ASSY LINE</h1>
      <GridInputs
        id={'tcs_end_ok_qty'}
        name={'tcs_end_ok_qty'}
        html_for={'tcs_end_ok_qty'}
        label_name={'OK:'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.tcs_end_ok_qty || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'tcs_end_ng_qty'}
        name={'tcs_end_ng_qty'}
        html_for={'tcs_end_ng_qty'}
        label_name={'NG:'}
        input_type={'number'}
        focusType={'onblur'}
        value={data?.tcs_end_ng_qty || ''}
        onChange={handleCustomerData}
      />
      <StyledNotesField>
        <DescriptionTextfield
          name="root_cause"
          onChange={handleCustomerData}
          value={data?.root_cause || ''}
          label={'Root Cause:'}
        />
      </StyledNotesField>
      <StyledNotesField>
        <DescriptionTextfield
          name="counter_measure_one"
          onChange={handleCustomerData}
          value={data?.counter_measure_one || ''}
          label={'Counter Measure 1 :'}
        />
      </StyledNotesField>
      <StyledNotesField>
        <DescriptionTextfield
          name="counter_measure_two"
          onChange={handleCustomerData}
          value={data?.counter_measure_two || ''}
          label={'Counter Measure 2 :'}
        />
      </StyledNotesField>
      <StyledNotesField>
        <DescriptionTextfield
          name="counter_measure_three"
          onChange={handleCustomerData}
          value={data?.counter_measure_three || ''}
          label={'Counter Measure 3 :'}
        />
      </StyledNotesField>
      <GridInputs
        id={'responsibility'}
        name={'responsibility'}
        html_for={'responsibility'}
        label_name={'Responsibility:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.responsibility || ''}
        onChange={handleCustomerData}
      />
      <GridDatePicker
        label_name="Target Date"
        html_for={'target_date'}
        value={data?.target_date || null}
        onChange={(date) => {
          data.target_date = date;
        }}
      />
      <GridDatePicker
        label_name="Impl. Date"
        html_for={'implement_date'}
        value={data?.implement_date || null}
        onChange={(date) => {
          data.implement_date = date;
        }}
      />
      <h1>Effectivness</h1>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any, index: number) => {
        return (
          <>
            <h1>Lot - {num}</h1>
            <GridDatePicker
              label_name={`Date`}
              html_for={`date`}
              value={data?.effectivness?.[index]?.date || null}
              onChange={(date) => {
                data.effectivness[index].date = date;
              }}
            />
            <GridInputs
              id={`invoice_no`}
              name={`invoice_no`}
              html_for={`invoice_no`}
              label_name={'INVOICE NO. :'}
              input_type={'text'}
              focusType={'onblur'}
              value={data?.effectivness?.[index]?.invoice_no || ''}
              onChange={(e: any) => {
                data.effectivness[index][e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
            />
            <GridInputs
              id={`qty`}
              name={`qty`}
              html_for={`qty`}
              label_name={'QTY. :'}
              input_type={'number'}
              focusType={'onblur'}
              value={data?.effectivness?.[index]?.qty || ''}
              onChange={(e) => {
                data.effectivness[index][e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
            />
            <GridSelect
              name={`status`}
              label_name="STATUS :"
              html_for={`status`}
              value={data?.effectivness?.[index]?.status || ''}
              onChange={(e) => {
                data.effectivness[index][e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
            >
              <MenuItem value="OK">OK</MenuItem>
              <MenuItem value="NG">NG</MenuItem>
            </GridSelect>
          </>
        );
      })}
      <h1>HD EVIDENCE PART NO</h1>
      <GridInputs
        id={'hd_evidence_part_no_one'}
        name={'hd_evidence_part_no_one'}
        html_for={'hd_evidence_part_no_one'}
        label_name={'1 :'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.hd_evidence_part_no_one || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'hd_evidence_part_no_two'}
        name={'hd_evidence_part_no_two'}
        html_for={'hd_evidence_part_no_two'}
        label_name={'2 :'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.hd_evidence_part_no_two || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'hd_evidence_part_no_three'}
        name={'hd_evidence_part_no_three'}
        html_for={'hd_evidence_part_no_three'}
        label_name={'3 :'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.hd_evidence_part_no_three || ''}
        onChange={handleCustomerData}
      />
      <StyledNotesField>
        <DescriptionTextfield
          name="hd_evidence"
          onChange={handleCustomerData}
          value={data?.hd_evidence || ''}
          label={'HD EVIDENCE :'}
        />
      </StyledNotesField>
      <Grid item xs={3}>
        <CustomUploadButton
          lable={'Defect photo'}
          multiple
          accept="image/png,image/jpeg,image/jpg"
          onChange={(e) => {
            if (files) {
              setFiles([...files, ...e.target.files]);
            } else {
              setFiles(e.target.files);
            }
          }}
        />{' '}
      </Grid>
      <Grid item xs={3}>
        <CustomUploadButton
          lable={'Attach Supporting Doucments'}
          multiple
          accept="application/pdf,application/doc,application/excel/,application/ppt"
          onChange={(e) => {
            if (files) {
              setFiles([...files, ...e.target.files]);
            } else {
              setFiles(e.target.files);
            }
          }}
        />{' '}
      </Grid>
      <div>
        <Checkbox
          name="exclude_report"
          checked={data?.exclude_report}
          onChange={(e) => {
            setData((prev: any) => ({
              ...prev,
              [e.target.name]: e.target.checked,
            }));
          }}
        />

        <span
          style={{
            fontWeight: '500',
            fontSize: '20px',
          }}
        >
          Exclude from report
        </span>
      </div>

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
      <ModalCustom
        openModal={isPartModal}
        closeModal={() => {
          setIsPartModal(false);
        }}
        title="PART"
      >
        <PartTable moduleData={data} />
      </ModalCustom>
    </>
  );
};

export default Create;
